
import angular from 'angular';


const controllerInfo = {
    module: 'ib-ancillaries-modal-module',
    inject: ['$scope', '$uibModalInstance', 'object', 'DatalayerUtilsService', '$rootScope'],
    required: []
};

export class UpgradeKnowMoreController implements ng.IController {

    public model;
    constructor (
        private $scope: CommonsScope,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private object: any,
        private DatalayerUtilsService: DatalayerUtilsService,
        private $rootScope: CommonsRootScope) {
        this.model = object;
    }

    /**
    * Initialize modal controller
     */
    activate = (): void => {
        this.DatalayerUtilsService.sendDatalayerModalEvent(this.model);
        this.$scope.slickConfig = {
            arrows: false
        };
        this.$uibModalInstance.result.then(this.DatalayerUtilsService.removeDatalayerModalAttrs, this.DatalayerUtilsService.removeDatalayerModalAttrs);
    };


    /**
     * Cllose modal
     */
    close = (): void => {
        this.$uibModalInstance.dismiss('dismiss');
    };

    /**
     * Load the new offer
     * @param {Integer,indexSelected Index of offer to load
     */
    loadOffer = (currentCabin: any, segmentInfo: any, indexSelected: any): void => {
        close();
        this.$rootScope.$broadcast('openOfferCondition', { currentCabin: currentCabin, segmentInfo: segmentInfo, offerSelected: indexSelected });
    };
}


try {
    UpgradeKnowMoreController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(UpgradeKnowMoreController.name, UpgradeKnowMoreController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    UpgradeKnowMoreController.$inject = controllerInfo.inject;
    mod.controller(UpgradeKnowMoreController.name, UpgradeKnowMoreController);
}